/* =============================================
   Products Cards — Slick Slider Init
   Lazy via IntersectionObserver.
   Slick + jQuery loaded on demand, only if
   slider is actually enabled in settings.
   ============================================= */
(function () {
  'use strict';

  var initialized = {};

  /* SVG arrows injected as custom Slick HTML */
  var PREV_ARROW =
    '<button type="button" class="pc-arr pc-arr--p" aria-label="Previous slide">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<polyline points="15 18 9 12 15 6"/>' +
      '</svg>' +
    '</button>';

  var NEXT_ARROW =
    '<button type="button" class="pc-arr pc-arr--n" aria-label="Next slide">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<polyline points="9 18 15 12 9 6"/>' +
      '</svg>' +
    '</button>';

  /* ── Main init for a section element ── */
  function initSection(sectionEl) {
    var id = sectionEl.dataset.sectionId;
    if (initialized[id]) return;

    var grid     = sectionEl.querySelector('[data-pc-grid]');
    var controls = sectionEl.querySelector('[data-pc-controls]');
    if (!grid) return;

    var cfg       = (window.pcData && window.pcData[id]) || {};
    var isMobile  = window.matchMedia('(max-width: 749px)').matches;
    var shouldSlide = (isMobile && cfg.enableMobile === true) ||
                      (!isMobile && cfg.enableDesktop === true);

    if (!shouldSlide) return;
    initialized[id] = true;

    var desktopSlides = parseInt(cfg.desktopSlides, 10) || 3;
    var slidesToShow  = isMobile ? 1 : desktopSlides;

    loadSlider(function () {
      if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;

      var $grid     = jQuery(grid);
      var $controls = controls ? jQuery(controls) : null;

      $grid.slick({
        slidesToShow:   slidesToShow,
        slidesToScroll: 1,
        autoplay:       cfg.autoplay === true,
        autoplaySpeed:  parseInt(cfg.autoplaySpeed, 10) || 3000,
        dots:           true,
        arrows:         true,
        infinite:       true,
        speed:          440,
        cssEase:        'cubic-bezier(0.25, 0.46, 0.45, 0.94)',

        /* Inject custom arrows */
        prevArrow: PREV_ARROW,
        nextArrow: NEXT_ARROW,

        /* Inject custom dot paging */
        customPaging: function () {
          return '<button type="button" aria-label="Go to slide"><span class="pc-dot"></span></button>';
        },

        /* Append both arrows and dots into our controls bar */
        appendArrows: $controls,
        appendDots:   $controls,

        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: Math.min(2, slidesToShow)
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow:   1,
              slidesToScroll: 1
            }
          }
        ]
      });

      /* Reveal controls bar once Slick has populated it */
      if ($controls) {
        $controls.addClass('pc-controls--visible').removeAttr('aria-hidden');
      }
    });
  }

  /* ── Load jQuery → Slick on demand ── */
  function loadSlider(cb) {
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      cb();
      return;
    }

    function attachSlickCSS() {
      [
        'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css',
        'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css'
      ].forEach(function (href) {
        if (!document.querySelector('link[href="' + href + '"]')) {
          var l    = document.createElement('link');
          l.rel    = 'stylesheet';
          l.href   = href;
          document.head.appendChild(l);
        }
      });
    }

    function loadSlickJS() {
      if (typeof jQuery.fn.slick !== 'undefined') { cb(); return; }
      attachSlickCSS();
      appendScript('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js', cb);
    }

    if (typeof jQuery === 'undefined') {
      appendScript('https://code.jquery.com/jquery-3.6.4.min.js', loadSlickJS);
    } else {
      loadSlickJS();
    }
  }

  function appendScript(src, onload) {
    var s    = document.createElement('script');
    s.src    = src;
    s.async  = true;
    s.onload = onload;
    document.head.appendChild(s);
  }

  /* ── Observe sections; init when they scroll into view ── */
  function observe() {
    var sections = document.querySelectorAll('.products-cards');
    if (!sections.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            initSection(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' });

      sections.forEach(function (s) { io.observe(s); });
    } else {
      sections.forEach(initSection);
    }
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  /* ── Shopify Theme Editor live-reload ── */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.products-cards');
    if (!section) return;

    var id       = section.dataset.sectionId;
    var grid     = section.querySelector('[data-pc-grid]');
    var controls = section.querySelector('[data-pc-controls]');

    if (grid && typeof jQuery !== 'undefined' && jQuery(grid).hasClass('slick-initialized')) {
      jQuery(grid).slick('unslick');
    }

    if (controls) {
      controls.innerHTML = '';
      jQuery(controls).removeClass('pc-controls--visible').attr('aria-hidden', 'true');
    }

    delete initialized[id];
    initSection(section);
  });

})();

/* =============================================
   Products Cards — Info Popup
   ============================================= */
(function () {
  'use strict';

  var ESC_ATTACHED = false;

  function closeAnyOpen() {
    var open = document.querySelector('.pc__popup-overlay.pc__popup--open');
    if (!open) return;
    open.classList.remove('pc__popup--open');
    open.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function initPopups() {
    document.querySelectorAll('.products-cards').forEach(function (section) {
      var overlay = section.querySelector('[data-pc-popup-overlay]');
      if (!overlay || overlay._pcBound) return;
      overlay._pcBound = true;

      var popup     = overlay.querySelector('.pc__popup');
      var titleEl   = overlay.querySelector('.pc__popup-title');
      var bodyEl    = overlay.querySelector('.pc__popup-body');
      var closeBtn  = overlay.querySelector('.pc__popup-close');
      var activeBtn = null;

      function closePopup() {
        overlay.classList.remove('pc__popup--open');
        overlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (activeBtn) { activeBtn.focus(); activeBtn = null; }
      }

      function openPopup(btn) {
        closeAnyOpen();

        var isMobile  = window.matchMedia('(max-width: 749px)').matches;
        var title     = btn.getAttribute('data-popup-title') || '';
        var srcId     = btn.getAttribute('data-popup-content-id');
        var srcEl     = srcId ? document.getElementById(srcId) : null;
        var titleFs      = btn.getAttribute(isMobile ? 'data-popup-title-mobile-fs' : 'data-popup-title-fs') || (isMobile ? '18' : '22');
        var bodyFs       = btn.getAttribute(isMobile ? 'data-popup-body-mobile-fs'  : 'data-popup-body-fs')  || (isMobile ? '13' : '15');
        var popupBg      = btn.getAttribute('data-popup-bg');
        var titleColor   = btn.getAttribute('data-popup-title-color');
        var bodyColor    = btn.getAttribute('data-popup-body-color');

        titleEl.textContent = title;
        bodyEl.innerHTML    = srcEl ? srcEl.innerHTML : '';
        popup.style.setProperty('--pc-popup-title-fs',    titleFs + 'px');
        popup.style.setProperty('--pc-popup-body-fs',     bodyFs  + 'px');
        popup.style.setProperty('--pc-popup-bg',          popupBg    || '');
        popup.style.setProperty('--pc-popup-title-color', titleColor || '');
        popup.style.setProperty('--pc-popup-body-color',  bodyColor  || '');

        overlay.classList.add('pc__popup--open');
        overlay.removeAttribute('aria-hidden');
        document.body.style.overflow = 'hidden';
        activeBtn = btn;
        closeBtn.focus();
      }

      section.addEventListener('click', function (e) {
        var btn = e.target.closest('.pc__info-btn');
        if (btn) openPopup(btn);
      });

      closeBtn.addEventListener('click', closePopup);

      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closePopup();
      });
    });

    if (!ESC_ATTACHED) {
      ESC_ATTACHED = true;
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeAnyOpen();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPopups);
  } else {
    initPopups();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.products-cards')) initPopups();
  });

})();
